function getSectionWiseData(section) {
  // retrieves the count of selected options of the required section

  let qCount = 0;
  if (section === 'm') qCount = 50;
  else if (section === 'l') qCount = 40;
  else if (section === 'c') qCount = 10;
  else if (section === 'e') qCount = 20;
  else return;

  let optionArray = [];
  for (let i = 1; i <= qCount; i++)
    optionArray.push(document.querySelector(`#${section}q-${i} .options input[name='${section}q-${i}']:checked`).value)

  // console.log(optionArray);

  let correctCount = 0;
  let wrongCount = 0;
  let unattemptedCount = 0;

  optionArray.forEach((el) => {
    if (el === 'u') unattemptedCount += 1;
    if (el === 'c') correctCount += 1;
    if (el === 'w') wrongCount += 1;
  });

  const summary = {
    correct: correctCount,
    wrong: wrongCount,
    attempted: qCount - unattemptedCount
  };

  return summary;
}

export default getSectionWiseData;
